// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__bBgf3","welcomeContainer":"Welcome_welcomeContainer__sexWg"};